import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/services/loading.service';
import { SubscriptionService } from 'src/app/services/subscriptions/subscription.service';

@Component({
  selector: 'app-disconnect-subscription-modal',
  standalone: false,
  templateUrl: './disconnect-subscription-modal.component.html',
  styleUrl: './disconnect-subscription-modal.component.scss',
})
export class DisconnectSubscriptionModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Output() onCancel = new EventEmitter();
  @Output() onDisconnect = new EventEmitter();

  @Input() providerTenantId!: string;

  constructor(
    private toastrService: ToastrService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private subscriptionService: SubscriptionService
  ) {

  }

  disconnect() {
     this.loadingService.load(
      this.subscriptionService.cancelSubscription(this.providerTenantId)
    ).subscribe(() => {
      this.toastrService.success(
        this.translateService.instant('SUBSCRIPTIONS.CANCELLED-SUBSCRIPTION-SUCCESSFULLY')
      );

      this.onDisconnect.emit();
      this.close();
    });
  }

  cancel() {
    this.onCancel.emit();
    this.close();
  }

  private close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
